// @flow

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';
import MenuPartCategoryView from './MenuPartCategoryView';

class MenuPartMainCategoryView extends React.Component {
  render() {
    const { menuInfo } = this.props;

    const rootCategory = menuInfo.menuPart.getRootCategory();

    try {
      return (
        <div>
          {/* Category listing */}
          <MenuPartCategoryView
            menuInfo={menuInfo}
            category={rootCategory}
            isRoot
          />
        </div>
      );
    } catch (e) {
      console.error(e);
    }
  }
}

export default MenuPartMainCategoryView;



// WEBPACK FOOTER //
// ./scripts/pages/menu/menuPartEdit/components/MenuPartMainCategoryView.js